import React from 'react'
import ReactMarkdown from 'react-markdown'
import classNames from 'classnames'
import { Section } from '../../../../index'

const ProfileLeft = props => {
  const {
    content: { markdown, images, metadata },
  } = props
  return (
    <Section
      className={classNames('profile-left', metadata && metadata.className)}
      innerClassName="intro__wrapper"
      isCentered
    >
      <section className="profile-left__images">
        <div className="profile-left__left">
          {images.map(({ id, title, sizes }) => (
            <img
              key={id}
              className="profile-left__image"
              src={sizes.src}
              srcSet={sizes.srcSet.split('fm=jpg').join('fm=jpg&fl=progressive')}
              sizes="50vw"
              alt={title}
            />
          ))}
        </div>
      </section>
      <section className="profile-left__markdown">
        <ReactMarkdown escapeHtml={false} source={markdown.content} />
      </section>
      <hr />
    </Section>
  )
}

export default ProfileLeft
